import React from 'react'
import './css/services.css'
import case3 from './images/case3.png'
import case2 from './images/case2.png'
import case1 from './images/case1.png'


export default function CaseStudy() {
    const flipBoxes = [
        {
          frontImage: case3,
          title: 'Audi',
          description: 'What an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what.'
        },
        {
          frontImage: case1,
          title: 'Audi',
          description: 'What an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what.'
        },
        {
          frontImage: case2,
          title: 'Audi',
          description: 'What an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what.'
        },
        {
          frontImage: case3,
          title: 'Audi',
          description: 'What an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what an amazing city what.'
        }
      ];
  return (
    <>

<div className="client-main1">
      <div className="client-heading">
        <h1>CASE STUDY
        </h1>
      </div>
      <div className="client-para">
        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim 
        ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>
      </div>
      </div>
      <div className="row section-flipbox">
      {flipBoxes.map((box, index) => (
        <div className={`col-md-3 ${index % 2 !== 0 ? 'margin-down' : ''}`} key={index}>
          <div className="flip-box">
            <div className="flip-box-inner">
              <div className="flip-box-front">
                <img src={box.frontImage} alt="Front" />
              </div>
              <div className="flip-box-back">
                <h2>{box.title}</h2>
                <p>{box.description}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
    </>
  )
}
